var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-sm-and-up bg"},[_c('div',{staticClass:"mobile_callme_wrap"},[_c('p',[_vm._v(" Copyright ©2025 上海易曙软件有限公司 . All Rights Reserved . 沪ICP备17033433号-5 ")])]),_c('div',{staticClass:"navigate_wrap"},[_c('span',[_vm._v("友情链接:")]),_c('a',{attrs:{"href":"https://www.tungee.com/"}},[_vm._v("探迹科技")])])])
}]

export { render, staticRenderFns }